import { useEffect, useState } from "react"
import { Table, Badge } from "reactstrap";
import consorcioService from "services/ConsorcioService"

export default function ({ idConsorcio }) {
  const [responsaveisTecnicos, setResponsaveisTecnicos] = useState([])
  const [prepostos, setPrepostos] = useState([])

  useEffect(() => {
    if (idConsorcio) {
      consorcioService.getResponsavelTecnico(idConsorcio).then(res => {
        if (res.success) {
          setResponsaveisTecnicos(res.data)
        } else {
          setResponsaveisTecnicos([])
        }
      })
      consorcioService.getPreposto(idConsorcio).then(res => {
        if (res.success) {
          setPrepostos(res.data)
        } else {
          setPrepostos([])
        }
      })
    }
  }, [idConsorcio])

  return (
    <>
      <div className="col-12">
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Empresa</th>
              <th scope="col">Telefone</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={4} className="text-center">
                <h4>RESPONSÁVEIS TÉCNICOS</h4>
              </td>
            </tr>
            {responsaveisTecnicos.length === 0 || false && (
              <tr>
                <td colSpan={4} className="text-center">Nenhum registro</td>
              </tr>
            )}
            {responsaveisTecnicos.map(el => (
              <tr key={el.id}>
                <td>{el.nome}</td>
                <td>
                  {el.empresa.razaoSocial}
                  {el.empresa.lider && (
                    <Badge color="success" className="ml-2">Líder</Badge>
                  )}

                </td>
                <td>{el.telefone}</td>
                <td>{el.email}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={4} className="text-center">
                <h4>PREPOSTOS</h4>
              </td>
            </tr>
            {prepostos.map(el => (
              <tr key={el.id}>
                <td>{el.nome}</td>
                <td>
                  {el.empresa.razaoSocial}
                  {el.empresa.lider && (
                    <Badge color="success" className="ml-2">Líder</Badge>
                  )}
                </td>
                <td>{el.telefone}</td>
                <td>{el.email}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  )
}